"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=IAggregatedStore.js.map